import { HiddenIcon, ShownIcon } from 'canoe';
import React, { useCallback } from 'react';

import { ValueBox, ValueGroup, ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  showLabel?: boolean;
  setProps: (props: Record<string, any>) => void;
  inputNamePrefix?: string;
}

export const LabelVisibility = ({ showLabel, setProps, inputNamePrefix = 'form-input' }: Props) => {
  const onSetVisibility = useCallback(
    (value: string) => {
      setProps({ showLabel: value === 'show' });
    },
    [setProps],
  );

  return (
    <ValueGroup>
      <ValueBox label="Label visibility">
        <ValueToggle
          toggleGroup={`${inputNamePrefix}-label-visibility`}
          onClick={() => onSetVisibility('show')}
          isActive={showLabel}
          icon={ShownIcon}
        />
        <ValueToggle
          toggleGroup={`${inputNamePrefix}-label-visibility`}
          onClick={() => onSetVisibility('hide')}
          isActive={!showLabel}
          icon={HiddenIcon}
        />
      </ValueBox>
    </ValueGroup>
  );
};
